/* =====================================================
   TM — PDP Blocks JS
   Función: interacciones de bloques pequeños PDP
===================================================== */

(function () {
  function initTmMiniReviewCarousel() {
    document.querySelectorAll('[data-tm-mini-review-carousel]').forEach(function (carousel) {
      if (carousel.dataset.tmMiniReviewReady === 'true') return;

      var track = carousel.querySelector('.tm-mini-review-track');
      var slides = carousel.querySelectorAll('.tm-mini-review-slide');
      var prev = carousel.querySelector('[data-tm-mini-prev]');
      var next = carousel.querySelector('[data-tm-mini-next]');
      var dotsWrapper = carousel.querySelector('[data-tm-mini-dots]');
      var current = 0;

      if (!track || !dotsWrapper || slides.length <= 1) return;

      dotsWrapper.innerHTML = '';

      slides.forEach(function (_, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'tm-mini-review-dot';
        dot.setAttribute('aria-label', 'Ver testimonio ' + (index + 1));

        dot.addEventListener('click', function () {
          current = index;
          updateCarousel();
        });

        dotsWrapper.appendChild(dot);
      });

      var dots = carousel.querySelectorAll('.tm-mini-review-dot');

      function updateCarousel() {
        track.style.transform = 'translateX(-' + current * 100 + '%)';

        dots.forEach(function (dot, index) {
          dot.classList.toggle('is-active', index === current);
        });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          current = current === 0 ? slides.length - 1 : current - 1;
          updateCarousel();
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          current = current === slides.length - 1 ? 0 : current + 1;
          updateCarousel();
        });
      }

      carousel.dataset.tmMiniReviewReady = 'true';
      updateCarousel();
    });
  }

  function bootTmPdpBlocks() {
    initTmMiniReviewCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootTmPdpBlocks);
  } else {
    bootTmPdpBlocks();
  }

  document.addEventListener('shopify:section:load', bootTmPdpBlocks);
})();